<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="150px">
    <el-form-item label="帐号">
      <el-input v-model="form.name" readonly />
    </el-form-item>
    <el-form-item label="密码" prop="pw">
      <el-input v-model="form.pw" show-password />
    </el-form-item>
  </el-form>
</template>

<script>
import md5 from 'md5'

export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        pw: [{ required: true, message: '必填项', trigger: 'change' }]
      }
    }
  },
  computed: {},
  mounted: function() {
    // console.log(this.form, "form");
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          var data = Object.assign({}, this.form)
          data.pw = md5(data.name + data.pw + data.name).toUpperCase()
          onValid(data)
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.flex-item {
  display: flex;
  width: 95%;
  & > .el-form-item {
    flex: 0 0 25%;
    display: flex;

    & .el-input,
    &.el-select {
      width: 100%;
    }
  }
}
</style>
